<template>
  <ChiCard className="px-3 pt-3">
    <div class="-mx-3 p-3 flex flex-row justify-around items-center">
      <div class="w-1/3">
        <Photo
          size="small"
          :src="aupair.profilePhoto"
          :alt="aupair.firstName"
        />
      </div>

      <div class="w-2/3 text-center">
        <AuPairName :name="aupair.firstName" />
        <Nationality :birthCountry="aupair.birthCountry" />
        <Age :age="aupair.birthDate" />
      </div>
    </div>
    <slot />
  </ChiCard>
</template>

<script>
import ChiCard from "@/components/UI/ChiCard.vue";
import AuPairName from "@/components/AuPairs/AuPairCardItems/AuPairName.vue";
import Photo from "@/components/AuPairs/AuPairCardItems/Photo.vue";
import Nationality from "@/components/AuPairs/AuPairCardItems/Nationality.vue";
import Age from "@/components/AuPairs/AuPairCardItems/Age.vue";

export default {
  name: "AuPairShortCard",
  props: {
    aupair: Object,
  },
  components: {
    ChiCard,
    AuPairName,
    Photo,
    Nationality,
    Age,
  },
};
</script>
